import { handleShare } from './handleShare';
import { setView } from './setView';
import { setLike } from './setLike';
import { breedPager } from './breedRecommendations'
// import { handleScroll } from './handleScroll';

document.addEventListener('DOMContentLoaded', function () {
  handleShare();
  setView();
  setLike();
  // handleScroll();
  breedPager('.expert_list--item', 3);
});
